// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__1qEM9","link":"login_link__2bcVJ","errorMessage":"login_errorMessage__3JWxv"};